import { getApiBase } from './apiBase';

export async function fetchLogsInventory() {
  const API = getApiBase();
  const res = await fetch(`${API}/api/logs/inventory`);
  if (!res.ok) throw new Error('Failed to fetch logs inventory');
  return res.json();
}

export async function fetchLogsTail({ instanceId, container, limit = 2000, cursor }) {
  const API = getApiBase();
  const params = new URLSearchParams({ instanceId, container, limit: String(limit) });
  if (cursor !== undefined && cursor !== null) params.set('cursor', String(cursor));
  const res = await fetch(`${API}/api/logs/tail?${params.toString()}`);
  if (!res.ok) throw new Error('Failed to fetch logs tail');
  return res.json();
}


